// extracted by mini-css-extract-plugin
module.exports = {"input-control":"SearchBar_input-control__2zJqG","search-button":"SearchBar_search-button__3nQ6P","search-icon":"SearchBar_search-icon__1vwQg"};